import mutations from './invoiceList.mutations'
import actions from './invoiceList.actions'
import getters from './invoiceList.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
